import { createIcon } from '@chakra-ui/react';

export const DisputeBoldIcon = createIcon({
  displayName: 'DisputeBoldIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="16"
        // height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <path
          d="M12.3133 11.7199L12.5733 13.8266C12.6399 14.3799 12.0466 14.7666 11.5733 14.4799L9.2666 13.1066C9.1066 13.0133 9.0666 12.8133 9.15326 12.6533C9.4866 12.0399 9.6666 11.3466 9.6666 10.6533C9.6666 8.21325 7.57326 6.22659 4.99993 6.22659C4.47326 6.22659 3.95993 6.30659 3.47993 6.46659C3.23326 6.54659 2.99326 6.31992 3.05326 6.06659C3.65993 3.63992 5.99326 1.83325 8.77993 1.83325C12.0333 1.83325 14.6666 4.29325 14.6666 7.32659C14.6666 9.12659 13.7399 10.7199 12.3133 11.7199Z"
          fill="#2B2448"
        />
        <path
          d="M8.66683 10.6532C8.66683 11.4466 8.3735 12.1799 7.88016 12.7599C7.22016 13.5599 6.1735 14.0732 5.00016 14.0732L3.26016 15.1066C2.96683 15.2866 2.5935 15.0399 2.6335 14.6999L2.80016 13.3866C1.90683 12.7666 1.3335 11.7732 1.3335 10.6532C1.3335 9.4799 1.96016 8.44656 2.92016 7.83323C3.5135 7.44656 4.22683 7.22656 5.00016 7.22656C7.02683 7.22656 8.66683 8.7599 8.66683 10.6532Z"
          fill="#2B2448"
        />
      </svg>
    </>
  ),
});
